import React from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";

const brands = [
  { name: "BMW", logo: "./BMW.jpg" },
  { name: "Audi", logo: "./AUDI.jpg" },
  { name: "BYD", logo: "./BYD.jpg" },
  { name: "Mercedes", logo: "./Mercedes.png" },
  { name: "Lexus", logo: "./LEXUS.jpg" },
  { name: "Porsche", logo: "./Porsche-Logo.png" },
  { name: "Tesla", logo: "./Tesla.png" },
  { name: "Jaguar", logo: "./JAGUAR.jpg" },
  { name: "LandRover", logo: "./LANDROVER.jpg" },
  { name: "Volvo", logo: "./VOLVO.png" },
  { name: "Ferrari", logo: "./FERRARI.png" },
  { name: "Lamborghini", logo: "./LAMBORGHINI.jpg" },
  { name: "Maserati", logo: "./MASERATI.png" },
  { name: "RollsRoyce", logo: "./ROLLS-ROYCE.png" },
  { name: "Bentley", logo: "./BENTLEY.jpg" },
  { name: "AstonMartin", logo: "./ASTON-MARTIN.jpg" },
  { name: "McLaren", logo: "./MCLAREN.jpg" },
  { name: "Bugatti", logo: "./BUGATTI.jpg" },
  { name: "Pagani", logo: "./PAGANI.webp" },
  { name: "Koenigsegg", logo: "./KOENIGSEGG.png" },
  { name: "AlfaRomeo", logo: "./ALFA-ROMEO.png" },
  { name: "Cadillac", logo: "./CADILLAC.jpg" },
  { name: "Infiniti", logo: "./INFINITI.webp" },
  { name: "Acura", logo: "./ACURA.png " },
  { name: "Genesis", logo: "./GENESIS.jpg" },
  { name: "Lincoln", logo: "./LINCOLN.jpg" },
  { name: "Mitsubishi", logo: "./MITSUBISHI.png" },
  { name: "Subaru", logo: "./SUBARU.png" },
  { name: "Mazda", logo: "./MAZDA.png" },
  { name: "Honda", logo: "./HONDA.png" },
  { name: "Toyota", logo: "./TOYOTA.png" },
  { name: "Nissan", logo: "./NISSAN.png" },
  { name: "Hyundai", logo: "./HYUNDAI.png" },
  { name: "Kia", logo: "./KIA.jpg" },
  { name: "Jeep", logo: "./JEEP.jpg" },
  { name: "Chevrolet", logo: "./CHEVROLET.png" },
  { name: "Ford", logo: "./FORD.png" },
  { name: "Volkswagen", logo: "./VOLKSWAGEN.png" },
  { name: "Renault", logo: "./RENAULT.png" },
  { name: "Peugeot", logo: "./PEUGEOT.png" },
  { name: "Citroën", logo: "./CITROEN.png" },
  { name: "Skoda", logo: "./SKODA.png" },
  { name: "Seat", logo: "./SEAT.jpg" },
  { name: "Fiat", logo: "./FIAT.png" },
  { name: "Lancia", logo: "./LANCIA.jpg" },
  { name: "Dodge", logo: "./DODGE.jpg" },
  { name: "Ram", logo: "./RAM.png" },
  { name: "GMC", logo: "./GMC.png"},
  { name: "Chrysler", logo: "./CHRYSLER.png"},
  { name: "Buick", logo: "./BUICK.jpg"},
  { name: "xiaomi", logo: "./XIAOMI.png"},
  { name: "suzuki", logo: "./SUZUKI.png"},
  { name: "mahindra", logo: "./MAHINDRA.webp"},
  { name: "tata", logo: "./TATA.webp"},
  { name: "lotus", logo: "./LOTUS.png"},
  { name: "mini", logo: "./MINI.jpg"},
  { name: "ForceMotors", logo: "./FORCE-MOTORS.png"},
  { name: "gelly", logo: "./GELLY.jpg"},
  { name: "Chery", logo: "./CHERY.png"},
  { name: "Rimac", logo: "./RIMAC.webp"},
  { name: "MG", logo: "./MG.webp"},
  { name: "Smart", logo: "./SMART.jpg"},
  { name: "Opel", logo: "./OPEL.png"},
  { name: "Maybach", logo: "./MAYBACH.png"},
  { name: "HindustanMotors", logo: "./HINDUSTAN-MOTORS.png"},
  { name: "AshokLeyland", logo: "./ASHOK-LEYLAND.jpg"},
  { name: "Polestar", logo: "./POLESTAR.webp"},
  { name: "Rivian", logo: "./RIVIAN.png"},
  { name: "LucidMotors", logo: "./LUCID-MOTORS.webp"},
  { name: "Fisker", logo: "./FISKER.png"},
  { name: "Saab", logo: "./SAAB.png"},
  { name: "Scion", logo: "./SCION.png"},
  { name: "Hummer", logo: "./HUMMER.png"},
  { name: "GAC", logo: "./GAC.png"},
  { name: "Oldsmobile", logo: "./OLDSMOBILE.jpg"},
  { name: "Pontiac", logo: "./PONTIAC.png"},
  { name: "Saturn", logo: "./SATURN.webp"},
  { name: "Mercury", logo: "./MERCURY.png"},
  { name: "Plymouth", logo: "./PLYMOUTH.png"},
  { name: "Hino", logo: "./HINO.png"},
  { name: "Isuzu", logo: "./ISUZU.jpg"},
  { name: "Datsun", logo: "./DATSUN.webp"},
  { name: "Lada", logo: "./LADA.png"},
  { name: "Zotye", logo: "./ZOTYE.png"},
  { name: "Morgan", logo: "./MORGAN.png"},
  { name: "TVR", logo: "./TVR.jpg"},
  { name: "Ginetta", logo: "./GINETTA.png"},
  { name: "Ariel", logo: "./ARIEL.webp"},
  { name: "Caterham", logo: "./CATERHAM.png"},
  { name: "BAC", logo: "./BAC.png"},
];

const Brands = () => {
  const navigate = useNavigate();

  const handleClick = (brandName) => {
    navigate(`/brand/${brandName.toLowerCase()}`);
  };

  return (
    <>
      <head>
        <title>
          All Car Brands in India | Luxury, SUV & Electric Cars – CARZOO
        </title>

        <meta
          name="description"
          content="Explore all branded car companies including luxury cars, SUV cars, electric cars and premium brands. Compare car price in India and read expert car reviews."
        />

        <meta
          name="keywords"
          content="all car brands, luxury car brands, about branded cars, electric car brands in india, SUV cars, car price in india, compare branded cars, BMW, Audi, Mercedes, Tesla, Toyota, Tata, Mahindra"
        />

        <meta name="author" content="CARZOO" />
        <meta name="google-site-verification" content="cc6m8lYZbZqvaqNc19af3idK47cz4WRJbg38JIaQYBU" />

        <meta name="robots" content="index, follow" />

        <meta name="viewport" content="width=device-width, initial-scale=1" />

        <meta property="og:title" content="CARZOO - Premium Car Marketplace" />
        <meta property="og:description" content="Explore luxury cars, compare models and read reviews at CARZOO." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://carzoo.vercel.app/brands" />
        <meta property="og:image" content="https://carzoo.vercel.app/BMW.jpg" />

        <link rel="canonical" href="https://carzoo.vercel.app/" />

        <link rel="icon" type="image/png" href="/CARZOO-favicon.png" />

        <meta name="theme-color" content="#E35E56" />
      </head>

      <div className="brands-wrapper">
        <header className="brands-header">
          <h1>Explore All Branded Car Companies</h1>
          <p>
            Discover luxury cars, SUV cars, electric cars in India and compare
            branded car prices easily.
          </p>
        </header>

        <div className="brands-grid">
          {brands.map((brand, index) => (
            <div
              className="brand-card"
              key={index}
              onClick={() => handleClick(brand.name)}
              style={{ cursor: "pointer" }}
            >
              <div className="logo-box">
                <img src={brand.logo} alt={brand.name} />
              </div>
              <h3>{brand.name}</h3>
            </div>
          ))}
        </div>
        <section className="brands-seo-section">
          <h2>Top Luxury, SUV & Electric Car Brands in India</h2>

          <p>
            CARZOO brings together all major car brands in India and
            worldwide. From premium luxury cars like BMW, Mercedes and Audi
            to high-performance sports cars such as Ferrari, Lamborghini and
            Bugatti, our platform helps you explore every segment in one place.
          </p>

          <p>
            If you are searching for the latest electric cars in India, brands
            like Tesla, BYD, Tata and MG offer innovative EV technology with
            impressive range and performance. For reliable SUV cars and family
            vehicles, Toyota, Hyundai, Mahindra and Kia provide excellent build
            quality and competitive car prices in India.
          </p>

          <h3>Compare Car Price & Specifications Easily</h3>

          <p>
            With so many branded cars available in the market, comparing car
            price, engine specifications, mileage, fuel type and features is
            important before making a decision. CARZOO simplifies car
            comparison by providing detailed information, expert reviews and
            updated pricing for Indian cars and global brands.
          </p>

          <h3>Find the Perfect Car for Your Lifestyle</h3>

          <p>
            Whether you want a luxury sedan, a powerful SUV, a fuel-efficient
            hatchback or a modern electric vehicle, our car marketplace helps
            you explore top car brands and choose the right vehicle based on
            your budget and driving needs.
          </p>
        </section>
      </div>
    </>
  );
};

export default Brands;